import { render, staticRenderFns } from "./FormSettlementExternal.vue?vue&type=template&id=60b07346"
import script from "./FormSettlementExternal.vue?vue&type=script&lang=js"
export * from "./FormSettlementExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports